import { Customer } from 'types/Customer';

export interface CustomerState {
    customer?: Customer;
    loading: boolean;
    status: CustomerStatus;
}

export enum CustomerStatus {
    Initial,

    RequestAuthCodeStart,
    RequestAuthCodeSuccess,
    AuthenticateByAuthCodeStart,
    AuthenticateByAuthCodeSuccess,

    Error
}
